import { useEffect, useState } from 'react';

import client from '../api/client';

// GET /api/product/:id -> single product with category populated.
export default function useProduct(id) {
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      return undefined;
    }
    let active = true;
    setLoading(true);
    client
      .get(`/product/${id}`)
      .then(({ data }) => {
        if (!active) return;
        setProduct(data);
        setError(null);
      })
      .catch((err) => {
        if (!active) return;
        setError(err);
        setProduct(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [id]);

  return { product, loading, error };
}
